import React from 'react';
import MainLayout from '../components/Layout/MainLayout.js';

const FAQPage = () => {
    const faqs = [
        {
            question: "Hvordan kommer jeg i gang?",
            answer: "Det er nemt at komme i gang - indtast blot dit CVR-nummer på forsiden, så finder vi automatisk dine virksomhedsoplysninger og opretter din hjemmeside med AI-genereret indhold."
        },
        {
            question: "Hvad koster det?",
            answer: "Du får 3 måneders gratis prøveperiode uden binding. Herefter koster det kun 249 kr/md for en professionel hjemmeside med ubegrænset antal sider."
        },
        {
            question: "Kan jeg selv redigere indholdet?",
            answer: "Ja, du får adgang til et brugervenligt kontrolpanel, hvor du nemt kan redigere tekster, billeder, åbningstider, kontaktoplysninger og meget mere!"
        },
        {
            question: "Hvordan fungerer det AI-genererede indhold?",
            answer: "Vores AI analyserer din virksomheds data og branche for at generere professionelt og relevant indhold til din hjemmeside. Du kan altid redigere eller tilpasse indholdet efter behov."
        },
        {
            question: "Kan jeg bruge mit eget domæne?",
            answer: "Ja, du kan nemt tilknytte dit eget domæne til hjemmesiden. Vi guider dig gennem processen i kontrolpanelet."
        }
    ];

    return (
        <MainLayout>
            <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <h1 className="text-3xl font-bold font-montserrat text-gray-900 mb-8">
                    Ofte stillede spørgsmål
                </h1>
                
                <div className="space-y-6 max-w-4xl">
                    {faqs.map((faq, index) => (
                        <div key={index} className="bg-white shadow rounded-lg p-6">
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                {faq.question}
                            </h3>
                            <p className="text-gray-600">
                                {faq.answer}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </MainLayout>
    );
};

export default FAQPage;